import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';
import ScrollToPosition from './scroll-to-position.jsx';

if (document.getElementById('react-component-g4-logistics-portal-unplanned-jobs')) {
  ReactDOM.render(<><JobsTable
    url= "/api/v1/portal/jobs/unplanned"
    infiniteScroll={true}
    unplannedScreen={true}
    message_if_none = 'No jobs that are unplanned.'
  />
  {/* <ScrollToPosition page="jobs-unplanned"/> */}
  </>,
document.getElementById('react-component-g4-logistics-portal-unplanned-jobs'));
}
